import React from 'react'

interface CircularProgressMetricProps {
  score: number
  maxScore?: number
}

const CircularProgressMetric: React.FC<CircularProgressMetricProps> = ({
  score,
  maxScore = 100
}) => {
  const getStrokeColor = (): string => {
    if (score >= 95) return '#22c55e'
    if (score >= 90) return '#F0B100'
    return '#FB2C36'
  }

  const radius = 85
  const circumference = 2 * Math.PI * radius
  const progress = Math.min(Math.max(score, 0), maxScore) / maxScore
  const strokeDashoffset = circumference * (1 - progress)

  return (
    <div className="circular-metric-container">
      <div className="circular-progress-wrapper">
        <svg width="200" height="200" viewBox="0 0 200 200">
          <circle
            cx="100"
            cy="100"
            r="85"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="20"
          />
          <circle
            cx="100"
            cy="100"
            r="85"
            fill="none"
            stroke={getStrokeColor()}
            strokeWidth="20"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform="rotate(-90 100 100)"
          />
        </svg>
        <div className="circular-center-text">
          <div className="circular-score">{score.toFixed(0)}</div>
          <div className="circular-total">/{maxScore}</div>
        </div>
      </div>
    </div>
  )
}

export default CircularProgressMetric
